const handleDeleteServiceModalEquipService = {
  confirm: 'Deseja realmente deletar o serviço?',
  title: 'DELETAR SERVIÇO'
};

export default handleDeleteServiceModalEquipService;
